import Modal from './accessibility';

const galleryLinks = document.querySelectorAll('.image_gallery__trigger');
const body = document.querySelector('body');

if(galleryLinks.length){
  galleryLinks.forEach((link) => {
    link.addEventListener('click', () => {
      // Clone the image from the link
      const image = link.querySelector('figure');
      const clone = image.cloneNode(true);

      // Create the modal element markup
      const modal = document.createElement("div");
      const modalInner = document.createElement("div");
      const modalClose = document.createElement("button");

      // Add Classes
      modal.classList.add('image_gallery__modal');
      modalInner.classList.add('image_gallery__modal_inner');
      modalClose.classList.add('image_gallery__modal_close');

      // Construct modal element
      modalInner.append(clone);
      modalInner.append(modalClose);
      modal.append(modalInner);
      body.append(modal);

      // Fade in
      setTimeout(() => {
        modal.classList.add('active');
      }, 10);
      body.classList.add('scroll-lock');

      // Handles trapping focus in modal
      Modal.open(modal);
      modalClose.setAttribute('tabindex', '1');

      // Close
      modalClose.addEventListener('click', () => {
        closeModal(modal, link);
      });

      modal.addEventListener('click', (e) => {
        const clickedEl = e.target;
        if(clickedEl === modal){
          closeModal(modal, link);
        }
      });
    });
  });
}

function closeModal(modal, link){
  modal.classList.remove('active');
  body.classList.remove('scroll-lock');

  // Handles un-trapping focus in modal
  Modal.close(modal);

  // Set focus back to the link that was clicked
  link.focus();
  link.blur();

  // Remove element from document
  setTimeout(() => {
    modal.remove();
  }, 300);
}
